// extracted by mini-css-extract-plugin
export const productContainer = "productList-module--productContainer--18XI_";
export const cardCollection = "productList-module--cardCollection--23ZWs";
export const disabled = "productList-module--disabled--3drZO";
export const courseText = "productList-module--courseText--26Eb1";
export const floralContainer = "productList-module--floralContainer--3IyW4";
export const menuCategory = "productList-module--menuCategory--17C5s";